'use strict';

function getPosition(screen, screenX, screenY) {
  // Works with multiple monitors
  var left = ((screen.width / 2) - 300) + screenX;
  var top = ((screen.height / 2) - 250) + screenY;

  return {
    left: left,
    top: top
  };
}

function handleClick(e) {
  var elementClicked = e.target;

  if (elementClicked.classList.contains('js-social-connect')) {
    var position = getPosition(window.screen, window.screenX, window.screenY);

    window.open(elementClicked.getAttribute('data-url'), 'Twitter', 'width=600, height=560, left=' + position.left + ', top=' + position.top);
  }
}

document.addEventListener('click', handleClick);

module.exports = {
  getPosition: getPosition,
  handleClick: handleClick
};
